<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
.el-message {
	z-index: 9999!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue